<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosRegionSetting"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="deptIdList" label="区域">
              <CustomerAreaCascader
                appId="cos_fbu"
                deptInfoId="815717"
                type="search"
                :multiple="true"
                v-model:ids="queryForm.deptIdList"
              />
            </dc-form-item>
            <dc-form-item name="deptManagerId" label="区域负责人">
              <user-select v-model:value="queryForm.deptManagerId" />
            </dc-form-item>
            <dc-form-item name="deptScopeId" label="区域员工">
              <user-select v-model:value="queryForm.deptScopeId" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'deptManager'">
            {{ record.deptManagerInfo.map((emp) => `${emp.employeeName}(${emp.employeeNo})`).join(',') }}
          </template>
          <template v-if="column.dataIndex === 'deptScope'">
            {{ record.deptScopeInfo.map((emp) => `${emp.employeeName}(${emp.employeeNo})`).join(',') }}
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'fbu_region_setting_edit_btn'"
                >编辑</a-button
              >
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_region_setting_delete_btn'"
                >删除</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'fbu_region_setting_add_btn'">新增</a-button>
          <a-button type="primary" @click="sync()" v-permission="'fbu_region_setting_sync_btn'">同步区域员工</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
  <script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { ref, computed } from 'vue'
import {
  regionSettingList,
  syncRegionSetting,
  deleteRegionSetting,
  createRegionSetting,
  updateRegionSetting,
  regionList,
  detailRegionSetting
} from '@/api/gucangSales/regionSetting'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { Modal as AModal } from 'ant-design-vue'
export default { name: 'DcCosFbuRegionSetting' }
</script>
  <script setup lang="ts">
const editModalRef = ref<{ toggle: (row?: any) => void }>()

const tableRef = ref()
const queryForm = ref({})
// 获取列表
const fetch = async (params: any, callBack: (res: any) => void) => {
  try {
    const res = await regionSettingList({ ...params })
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '区域', dataIndex: 'deptName' },
  { title: '区域负责人', dataIndex: 'deptManager' },
  { title: '区域员工', dataIndex: 'deptScope' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: any) => {
  editModalRef.value?.toggle(_row)
}

const sync = () => {
  AModal.confirm({
    title: '提示',
    content: '是否立即更新区域下员工信息?',
    onOk() {
      syncRegionSetting().then(() => {
        DcMessage.success('同步成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
const deleteRow = (row: any) => {
  Modal.delete({
    name: row.deptName,
    onOk() {
      deleteRegionSetting({id: row.id}).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
</script>
  
  <style scoped></style>
  